import React from 'react';

const IconLoader = () => (
  <svg id="logo" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 375 375">
    <title>Loader Logo</title>
    <g>
      <path
        id="SM-border"
        d="M20 20h335v335H20z"
        fill="none"
        stroke="currentColor"
        strokeWidth="12"
      />
      <path
        id="SM"
        d="M85.7 108.1c-13.4 1.4-26.9 10.1-34.9 22.3-14.5 22.4-9.7 55.8 9.8 67.2 6.7 3.9 12.9 6 32.7 11 22.8 5.8 27.7 7.9 31.4 13.5 2.3 3.5 2.9 5.5 3.1 11.9.2 4.1-.1 9.4-.7 11.6-3.9 14.7-20.4 24.2-37.6 21.7-19-2.7-31.4-14-40.8-37.3-2.3-5.7-4.7-10.5-5.3-10.7-2.3-.8-2.6 47.1-.3 50.8 1 1.8 3.9-.8 8-7.2 3.2-5.1 3.3-5.1 8.4-1.4 4.6 3.4 12.4 7.1 19 9.1 8 2.3 23.8 2.4 32.4.1 25.8-6.9 39.1-25.1 39.1-53.3 0-17.4-4-28.3-13.9-37.8-7.7-7.3-12.9-9.6-33.8-15-18.9-4.9-24.6-7.3-28.9-11.7-2.8-2.9-2.9-3.5-3.2-13.5-.4-9.8-.2-10.7 2.3-14.9 5.5-9.5 15.9-13.7 28.2-11.5 15.5 2.7 24.6 11 31.8 29.1 5.6 14.1 6.5 12.1 6.4-13.6 0-9.9-.4-18.9-.8-19.9-.6-1.6-1.2-1.3-4.6 3-2.2 2.7-4 5-4.1 5.2 0 .1-4.3-1.7-9.5-4-5.8-2.5-11.3-4.3-14.4-4.5-2.7-.2-6.8-.5-9-.6-2.2-.2-7.1 0-10.8.4m74.8 2.9c-1.2 2 .7 3 6.1 3h5.5l-.3 71.7c-.2 48.4-.7 72.6-1.4 74.2-.6 1.4-3.1 3.4-5.5 4.5-2.4 1.2-4.4 2.8-4.4 3.6 0 1.3 2.3 1.5 14.5 1.5s14.5-.2 14.5-1.5c0-.8-2-2.4-4.4-3.6-2.4-1.1-4.9-3.1-5.5-4.5-.7-1.6-1.1-24.7-1.3-69.4l-.3-67 7.8 22c4.3 12.1 15.9 45.1 25.7 73.2l17.9 51.3h3.7c3.5 0 3.8-.3 5.2-4.2 3-8.7 47.9-134.4 49.2-137.8 1.2-3.1 1.4 0 1.4 24.5.1 15.4.4 47.2.8 70.7l.6 42.8h-6.1c-6 0-8.8 1.4-6.1 3.1.8.5 15.1.8 31.9.6 26.3-.2 30.5-.4 30.5-1.7 0-1.1-1.4-1.6-5.7-1.8l-5.8-.3V114h5.4c3.5 0 5.8-.5 6.6-1.5 1.9-2.3-1.4-2.6-28.4-2.3l-24.8.3-18.4 50.9c-10.1 28-18.6 51.1-18.9 51.4s-.8.3-1.1 0c-.7-.8-16.8-43.9-28.5-76.5l-9.4-26.3h-25.2c-15.7 0-25.4.4-25.8 1"
        fill="currentColor"
        stroke="none"
      />
    </g>
  </svg>
);

export default IconLoader;
